<template>
  <v-container fluid>
<!--    <v-card>
      <v-card-title>
        Received
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search (Item number, Total Yard etc..)"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :loading="test"
        :headers="headers"
        :items="desserts"
        :search="search"
      >
        <template v-slot:item.action="{ item }">
          <v-btn
            dark
            x-small
            text
            color="black"
            @click="getReceivedPDF(item.Receive_No)"
          >
            <v-icon>description</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>-->
    <data_table
      :displayname="'Received'"
      :loader="get_data_load"
      :options="false"
      :headers="headers"
      :items="ODP_data.Tubular"
      :search_text="search_text"
      :getPDF_func="$getPDFglobal"
      :pdf_params="[{'Tubular':'/getReceivedPDF'},'Receive_No']"
      :type="'Tubular'"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import data_table from '@/components/data_table.vue'
export default {
  name: 'received',
  components: { data_table },
  data () {
    return {
      search_text: 'Search (Item number, Total Yard etc..)',
      test: false,
      search: '',
      headers: [
        {
          text: 'Receive No',
          align: 'start',
          sortable: true,
          value: 'Receive_No'
        },
        { text: 'Returned Date', value: 'Returned_Date' },
        { text: 'Returned From', value: 'Returned_From' },
        { text: 'Location', value: 'Location' },
        { text: 'Item No', value: 'Item_No' },
        { text: 'Quantity Tubular', value: 'Quantity_Tubular' },
        { text: 'Equipment', value: 'Equipment' },
        { text: 'PDF', value: 'action', sortable: false }
      ],
      ODP_data: { Tubular: [], BHA: [] }
    }
  },
  computed: {
    ...mapGetters(['getUsername', 'get_data_load'])
  },
  mounted () {
    this.$initialDataLoad(this.$route.meta.backendRoutes, { username: this.$store.getters.getUsername }, 'Returned_Date')
    /* this.test = true
    axios
      .get('/getReceived', {
        params: { username: this.$store.getters.getUsername }
      })
      .then(response => {
        this.desserts = response.data
        this.test = false
      }) */
  },
  methods: {
    // getReceivedPDF (receivednr) {
    //   this.test = true
    //   axios
    //     .get('/getReceivedPDF', {
    //       params: { receivednr: receivednr }
    //     })
    //     .then(response => {
    //       this.test = false
    //       window.open(response.data.pdflink, '_blank')
    //     })
    // }
  }
}
</script>

<style>
</style>
